import { useEffect } from "react";
import { loggerService } from "@akina/infra";
import { isApp } from "@akina/utils";

const LOGGING_DOMAIN = "[useInterceptMediaCommands]";

export function useInterceptMediaCommands() {
  useEffect(() => {
    if (!isApp) return;

    if ("mediaSession" in navigator) {
      const handlers = {
        play: () => loggerService.info(LOGGING_DOMAIN, "Media play intercepted"),
        pause: () => loggerService.info(LOGGING_DOMAIN, "Media pause intercepted"),
        stop: () => loggerService.info(LOGGING_DOMAIN, "Media stop intercepted"),
        seekbackward: () => loggerService.info(LOGGING_DOMAIN, "Media previous intercepted"),
        seekforward: () => loggerService.info(LOGGING_DOMAIN, "Media next intercepted"),
        previoustrack: () => loggerService.info(LOGGING_DOMAIN, "Media previous track intercepted"),
        nexttrack: () => loggerService.info(LOGGING_DOMAIN, "Media next track intercepted"),
      };

      for (const [action, handler] of Object.entries(handlers)) {
        try {
          navigator.mediaSession.setActionHandler(action as MediaSessionAction, handler);
        } catch (error) {
          loggerService.error(LOGGING_DOMAIN, `Failed to set handler for ${action}:`, error);
        }
      }

      return () => {
        for (const action of Object.keys(handlers)) {
          try {
            navigator.mediaSession.setActionHandler(action as MediaSessionAction, null);
          } catch (error) {
            loggerService.error(LOGGING_DOMAIN, `Failed to remove handler for ${action}:`, error);
          }
        }
      };
    }
  }, []);
}
